// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
._zulpu2gc{gap:var(--ds-space-100,8px)}._1e0c1txw{display:flex}
._1tke1ylp{min-height:40px}
._4cvr1h6o{align-items:center}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-datasource/dist/esm/ui/common/modal/site-selector/index.compiled.css"],"names":[],"mappings":";AACA,WAAW,2BAA2B,CAAC,WAAW,YAAY;AAC9D,WAAW,eAAe;AAC1B,WAAW,kBAAkB","sourcesContent":["\n._zulpu2gc{gap:var(--ds-space-100,8px)}._1e0c1txw{display:flex}\n._1tke1ylp{min-height:40px}\n._4cvr1h6o{align-items:center}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
